import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/icons/non_active.svg'
import _imports_1 from '../assets/icons/phone.svg'


export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_mobile_support_button = _resolveComponent("mobile-support-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      class: "bottom-30px outline-none <sm:hidden absolute left-1000px appearance-none",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickHandler && _ctx.clickHandler(...args)))
    }, [
      _createElementVNode("span", {
        class: _normalizeClass([{ 'xl:-translate-y-40px': _ctx.scrolled, 'opacity-0': _ctx.scrolled }, "text-22px text-white fixed bottom-110px <xl:text-18px right-[calc(calc(50vw-720px)+245px)] <1300:right-245px transform-gpu z-200 <800:hidden mix-blend-difference transition-all duration-500"])
      }, "Поддержка", 2),
      _createElementVNode("img", {
        class: _normalizeClass([{ 'xl:-translate-y-40px': _ctx.scrolled }, "ml-15px fixed block z-200 bottom-90px w-66px <xl:w-58px <xl:h-58px right-[calc(calc(50vw-720px)+160px)] <1300:right-160px h-66px hover:scale-105 transform-gpu transition-all duration-500"]),
        src: _imports_0
      }, null, 2)
    ]),
    _createVNode(_component_mobile_support_button, {
      scrolled: _ctx.scrolled,
      clicked: _ctx.clicked,
      class: _normalizeClass([{ 'xl:-translate-y-40px': _ctx.scrolled }, "<sm:top-310px <xl:right-138px bottom-155px <sm:right-33px right-[calc(calc(50vw-720px)+178px)] <1300:right-174px"]),
      url: "https://telegram.me/AnnaKrist",
      img: require('../assets/icons/icon_telegram.svg')
    }, null, 8, ["scrolled", "clicked", "class", "img"]),
    _createVNode(_component_mobile_support_button, {
      scrolled: _ctx.scrolled,
      clicked: _ctx.clicked,
      class: _normalizeClass([{ 'xl:-translate-y-40px': _ctx.scrolled }, "<sm:top-348px <xl:right-136px bottom-200px <sm:right-33px right-[calc(calc(50vw-720px)+175px)] <1300:right-171px"]),
      url: "https://wa.me/79254182128",
      img: require('../assets/icons/icon_whatsapp.svg')
    }, null, 8, ["scrolled", "clicked", "class", "img"]),
    _createElementVNode("button", {
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickHandler && _ctx.clickHandler(...args))),
      class: "sm:hidden fixed top-385px right-22px z-200"
    }, _cache[2] || (_cache[2] = [
      _createElementVNode("img", {
        class: "w-45px h-45px",
        src: _imports_0
      }, null, -1)
    ])),
    _cache[3] || (_cache[3] = _createElementVNode("a", {
      href: "tel:+79254182128",
      class: "sm:hidden fixed top-440px right-22px z-200"
    }, [
      _createElementVNode("img", {
        class: "w-45px h-45px",
        src: _imports_1
      })
    ], -1))
  ], 64))
}